import { __decorate } from "tslib";
import { __metadata } from "tslib";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (_)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Product } from '../../schema';
import { Cache } from '../../core';
import { EShopService } from '../eshop';
var ProductsService = /*@__PURE__*/ (function () {
    function ProductsService() {
    }
    ProductsService.findAllSingleAttributes = function () {
        return __awaiter(this, void 0, void 0, function () {
            var eshop;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, EShopService.findAll()];
                    case 1:
                        eshop = _a.sent();
                        return [2 /*return*/, eshop.attributesMapped];
                }
            });
        });
    };
    ProductsService.findAllAttributeGroups = function () {
        return __awaiter(this, void 0, void 0, function () {
            var eshop;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, EShopService.findAll()];
                    case 1:
                        eshop = _a.sent();
                        return [2 /*return*/, eshop.attributeGroups];
                }
            });
        });
    };
    ProductsService.findOneAttributeById = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var attributes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ProductsService.findAllSingleAttributes()];
                    case 1:
                        attributes = _a.sent();
                        if (attributes[id]) {
                            return [2 /*return*/, attributes[id]];
                        }
                        throw new Error("Invalid attribute id " + id);
                }
            });
        });
    };
    ProductsService.findOneAttributeGroupById = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var groups;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ProductsService.findAllAttributeGroups()];
                    case 1:
                        groups = _a.sent();
                        if (groups[id]) {
                            return [2 /*return*/, groups[id]];
                        }
                        throw new Error("Invalid attribute id " + id);
                }
            });
        });
    };
    ProductsService.findAllCached = function () {
        return __awaiter(this, void 0, void 0, function () {
            var eshop;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, EShopService.findAll()];
                    case 1:
                        eshop = _a.sent();
                        return [2 /*return*/, eshop.products];
                }
            });
        });
    };
    ProductsService.findAll = function () {
        return __awaiter(this, void 0, void 0, function () {
            var products, result, _i, products_1, productData, product;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ProductsService.findAllCached()];
                    case 1:
                        products = _a.sent();
                        result = [];
                        for (_i = 0, products_1 = products; _i < products_1.length; _i++) {
                            productData = products_1[_i];
                            product = new Product;
                            product.loadJSON(productData);
                            result.push(product);
                        }
                        return [2 /*return*/, result];
                }
            });
        });
    };
    ProductsService.findOneById = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var products, _i, products_2, productData, product, _a, _b, subProduct, product;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, ProductsService.findAllCached()];
                    case 1:
                        products = _c.sent();
                        for (_i = 0, products_2 = products; _i < products_2.length; _i++) {
                            productData = products_2[_i];
                            if (productData.id === id) {
                                product = new Product;
                                product.loadJSON(productData);
                                return [2 /*return*/, product];
                            }
                            if (productData.products) {
                                for (_a = 0, _b = productData.products; _a < _b.length; _a++) {
                                    subProduct = _b[_a];
                                    if (subProduct.id === id) {
                                        product = new Product;
                                        product.loadJSON(productData);
                                        product.selectVersion(subProduct);
                                        if (product.currentVersionHasTopSmartphoneDeal()) {
                                            product.stopEventListeners();
                                            product.useTopSmartphoneDeal();
                                            product.resumeEventListeners();
                                        }
                                        return [2 /*return*/, product];
                                    }
                                }
                            }
                        }
                        throw new Error("Product id '" + id + "' is not existent.");
                }
            });
        });
    };
    ProductsService.findAllManufacturers = function () {
        return __awaiter(this, void 0, void 0, function () {
            var products, manufacturers, _i, products_3, productData, product, manufacturer;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ProductsService.findAllCached()];
                    case 1:
                        products = _a.sent();
                        manufacturers = [];
                        for (_i = 0, products_3 = products; _i < products_3.length; _i++) {
                            productData = products_3[_i];
                            product = new Product;
                            product.loadJSON(productData);
                            manufacturer = product.getManufacturer();
                            if (manufacturers.indexOf(manufacturer) > -1) {
                                continue;
                            }
                            manufacturers.push(manufacturer);
                        }
                        return [2 /*return*/, manufacturers];
                }
            });
        });
    };
    ProductsService.findAllManufacturersOfVoice = function () {
        return __awaiter(this, void 0, void 0, function () {
            var products, manufacturers, _i, products_4, productData, product, manufacturer;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ProductsService.findAllCached()];
                    case 1:
                        products = _a.sent();
                        manufacturers = [];
                        for (_i = 0, products_4 = products; _i < products_4.length; _i++) {
                            productData = products_4[_i];
                            product = new Product;
                            product.loadJSON(productData);
                            manufacturer = product.getManufacturer();
                            if (manufacturers.indexOf(manufacturer) > -1 || product.getSubsidizedWith() !== 'voice') {
                                continue;
                            }
                            manufacturers.push(manufacturer);
                        }
                        return [2 /*return*/, manufacturers];
                }
            });
        });
    };
    ProductsService.findAllManufacturersOfData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var products, manufacturers, _i, products_5, productData, product, manufacturer;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ProductsService.findAllCached()];
                    case 1:
                        products = _a.sent();
                        manufacturers = [];
                        for (_i = 0, products_5 = products; _i < products_5.length; _i++) {
                            productData = products_5[_i];
                            product = new Product;
                            product.loadJSON(productData);
                            manufacturer = product.getManufacturer();
                            if (manufacturers.indexOf(manufacturer) > -1 || product.getSubsidizedWith() !== 'data') {
                                continue;
                            }
                            manufacturers.push(manufacturer);
                        }
                        return [2 /*return*/, manufacturers];
                }
            });
        });
    };
    __decorate([
        Cache(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], ProductsService, "findAllManufacturers", null);
    __decorate([
        Cache(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], ProductsService, "findAllManufacturersOfVoice", null);
    __decorate([
        Cache(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], ProductsService, "findAllManufacturersOfData", null);
    return ProductsService;
}());
export { ProductsService };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/services/products/products.ts
// module id = null
// module chunks = 